module.exports = {
    NUMSERIE_OBLIGATOIRE: 'NUMSERIE_OBLIGATOIRE',
    DATEACHAT_OBLIGATOIRE: 'DATEACHAT_OBLIGATOIRE',
    NUMIMEI_OBLIGATOIRE: 'NUMIMEI_OBLIGATOIRE',
    NUMLINE_OBLIGATOIRE: 'NUMLINE_OBLIGATOIRE',
    DATE_SERVICE_OBLIGATOIRE: 'DATE_SERVICE_OBLIGATOIRE',
}